import { useCallback } from "react";
import { useParams } from "react-router";

import { EditIcon } from "icons";
import theme from "theme";

import Box from "components/Box";
import Dialog from "components/Dialog";
import Paper from "components/Paper";
import Stack from "components/Stack";
import Text from "components/Text";
import toast from "components/Toast";

import LocationEditForm from "entities/Deal/components/OverviewLocation/LocationEditForm";
import { IDeal, updateProjectAddress, useDealDetails } from "entities/Deal/sdk";

export interface ILocationEditDialog {
  open: boolean;
  handleClose: () => void;
}

const LocationEditDialog: React.FC<ILocationEditDialog> = ({
  open,
  handleClose,
}) => {
  const params = useParams<{
    dealId: string;
  }>();
  const dealId = Number(params.dealId);

  const { data: deal, mutate: updateDeal } = useDealDetails({ dealId });

  const handleSubmit = useCallback(
    (data: Partial<IDeal["address"]>) =>
      updateProjectAddress(dealId, data).then(() => {
        if (deal) {
          updateDeal({ ...deal, ...data });
          toast.successMessage("Location successfully updated!");
          handleClose();
        }
      }),

    [dealId, deal, updateDeal, handleClose]
  );

  return (
    <Dialog open={open} maxWidth="md" fullWidth onClose={handleClose}>
      <Box>
        <Stack alignItems="center" data-testid="edit-location-dialog">
          <Paper
            sx={{
              padding: theme.spacing(8),
              width: "100%",
            }}
          >
            <Stack spacing={4}>
              <Stack direction="row" spacing={1}>
                <EditIcon
                  style={{
                    height: "40px",
                    width: "40px",
                  }}
                />
                <Text variant="h1" style={{ display: "flex" }}>
                  Location info
                </Text>
              </Stack>
              {deal && (
                <LocationEditForm
                  onSubmit={handleSubmit}
                  handleCancel={handleClose}
                  initialValues={{
                    street_address: deal.address.street_address,
                    city: deal.address.city,
                    zipcode: deal.address.zipcode,
                    state: deal.address.state,
                  }}
                />
              )}
            </Stack>
          </Paper>
        </Stack>
      </Box>
    </Dialog>
  );
};

export default LocationEditDialog;
